import React from 'react';

import { Divider } from 'lighthouse';

import { badgeProps } from '@/widgets/Badge/models';

const Badge = ({ label, color = 'default', icon, className, isIconOnly, size = 'medium', isRounded, isTransParent = true }: badgeProps) => {
    const colors = {
        default: { bgColor: 'bg-gray-500', textColor: 'text-gray-500' },
        primary: { bgColor: 'bg-primary', textColor: 'text-primary' },
        blackHighEmphasis: { bgColor: 'bg-blackHighEmphasis', textColor: 'text-white' },
        secondary: { bgColor: 'bg-secondary', textColor: 'text-secondary' },
        success: { bgColor: 'bg-success', textColor: 'text-success' },
        error: { bgColor: 'bg-red-500', textColor: 'text-red-500' },
        warning: { bgColor: 'bg-amber-400', textColor: 'text-amber-800' },
        info: { bgColor: 'bg-cyan-400', textColor: 'text-cyan-500' }
    } as const;

    const sizes = {
        small: {
            width: 'w-5',
            style: 'h-5 py-1 px-2'
        },
        medium: {
            width: 'w-6',
            style: 'h-6 py-1 px-3'
        }
    } as const;

    return (
        <span
            className={`${colors[color].bgColor} flex items-center px-2 py-1 ${isTransParent ? 'bg-opacity-10' : ''}
                ${isRounded ? 'rounded-full' : 'rounded-lg'} ${sizes[size].style} ${className}
                ${isIconOnly ? `${sizes[size].width} justify-center` : ''}`}>
            {!!icon && (
                <>
                    <div className={`${colors[color].textColor} flex items-center`}>{icon}</div>
                    {label && <Divider orientation='vertical' variant='middle' className={`${colors[color].textColor} mx-1 border-current`} />}
                </>
            )}
            <span
                className={`font-bold ${isTransParent ? colors[color].textColor : `${color === 'warning' ? 'text-neutral-900' : 'text-white'}`} ${
                    size === 'small' ? 'text-[10px]' : 'text-[12px]'
                }`}>
                {label}
            </span>
        </span>
    );
};

export default Badge;
